import { InputHTMLAttributes, forwardRef, useState } from "react";
import { cn } from "@/utils/cn";

export interface TextAreaInputProps extends InputHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
  error?: boolean;
  helperText?: string;
  prefixIcon?: React.ReactNode;
  prefixActiveIcon?: React.ReactNode;
  rows?: number;
}

export const TextAreaInput = forwardRef<HTMLTextAreaElement, TextAreaInputProps>(
  ({ className, error, helperText, prefixIcon, prefixActiveIcon, rows = 4, ...props }, ref) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
      <div className="relative w-full flex items-center">
        {prefixIcon && (
          <div className="absolute left-3 focus:text-red">
            {!isFocused ? prefixIcon : (prefixActiveIcon || prefixIcon)}
          </div>
        )}
        <textarea
          ref={ref}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          rows={rows}
          className={cn(
            "w-full px-3.5 pt-2 h-11 rounded-sm resize-none",
            "border border-[rgba(208,213,221,1)] hover:border-[rgba(102,112,133,1)] focus:outline-none focus:border-black",
            "text-[rgba(16,24,40,1)] text-sm font-normal",
            "placeholder:text-[rgba(152,162,179,1)]",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-[rgba(217,45,32,1)] hover:border-[rgba(217,45,32,1)] focus:border-[rgba(217,45,32,1)]",
            className,
            prefixIcon && "pl-10"
          )}
          {...props}
        />
        {helperText && (
          <p
            className={cn(
              "absolute left-1 -bottom-4 mt-1 text-xs",
              error ? "text-[rgba(217,45,32,1)]" : "text-[rgba(102,112,133,1)]"
            )}
          >
            {helperText}
          </p>
        )}
      </div>
    );
  }
);

TextAreaInput.displayName = "TextAreaInput";
